/** Whether the current user owns the active intervene session. */
export function userOwnsChat(user, currentUserId) {
  if (!user || currentUserId == null) return false;
  return `${user.intervened_by_user_id}` === `${currentUserId}`;
}
